import ApiService from './ApiService';
import { URLShortnerType, URLShortner } from '../models';
import ShortLinkQueries from '../queries/shortLink.queries';
import UtilsService from './UtilsService';
import store from '@/store';

function createURLShortnerToCampaign(url: string, campaignId: string) {
  const shortnerData = {
    retailer: {
      __type: 'Pointer',
      className: 'Retailer',
      objectId: store.state.auth.currentUser.retailer.objectId,
    } as any,
    campaign: {
      __type: 'Pointer',
      className: 'Campaign',
      objectId: campaignId,
    } as any,
    type: URLShortnerType.Campaign,
    destinationUrl: url,
  };
  return ApiService.post(`/parse/classes/URLShortner`, shortnerData).then((res) => ({
    ...shortnerData, ...res,
  }));
}

function getAllShortLink(campaignId: string): Promise<URLShortner[]> {
  const query = ShortLinkQueries.getAll(
    store.state.auth.currentUser.retailer.objectId,
    campaignId,
  );
  return ApiService.get(UtilsService.buildFullPath(query)).then((res) => res.results);
}

const ShortLinkService = {
  createURLShortnerToCampaign,
  getAllShortLink,
};

export default ShortLinkService;
